import React from 'react';
import PropTypes from 'prop-types';
import { Text, Link } from '@chakra-ui/react';

const Footer = ({footerData}) => {
    Footer.propTypes = {
        footerData: PropTypes.shape({
            siminnLogo: PropTypes.string.isRequired,
            contactSection: PropTypes.shape({
                address: PropTypes.string.isRequired,
                kennitala: PropTypes.string.isRequired,
                vsk: PropTypes.string.isRequired,
                phoneNumber: PropTypes.string.isRequired,
                storeOpenLabel: PropTypes.string.isRequired,
                storeClosedLabel: PropTypes.string.isRequired,
            }),
            contentSection: PropTypes.shape({
                columns: PropTypes.arrayOf(
                    PropTypes.shape({
                        title: PropTypes.string.isRequired,
                        linkItems: PropTypes.arrayOf(
                            PropTypes.shape({
                                label: PropTypes.string.isRequired,
                                url: PropTypes.string.isRequired,
                            })
                        ).isRequired,
                    })
                ).isRequired,
            }).isRequired,
            socialSection: PropTypes.shape({
                socialItems: PropTypes.arrayOf(
                    PropTypes.shape({
                        icon: PropTypes.string.isRequired,
                        link: PropTypes.string.isRequired,
                        label: PropTypes.string.isRequired
                    })
                ).isRequired,
            }).isRequired,
            certificationSection: PropTypes.shape({
                items: PropTypes.arrayOf(
                    PropTypes.shape({
                        icon: PropTypes.string.isRequired,
                        link: PropTypes.string.isRequired,
                        label: PropTypes.string.isRequired
                    })
                ).isRequired,
            }).isRequired,
            backLabel: PropTypes.string.isRequired,
            image: PropTypes.string.isRequired,
        }),
    };

    return (
        <footer className="footer">
            <div className="footerbottom">
                <div className="siminnlinkwrapper">
                    <Link href="https://www.siminn.is" className="siminnlink">
                        <img
                            src="../assets/icons/BackArrow.svg"
                            alt="BackArrow"
                        />
                        <Text>
                            {footerData.backLabel}
                        </Text>
                    </Link>
                </div>
                <div className="footervottunlogowrap desktop">
                    {footerData.certificationSection.items.map((element, index) => (
                        <a key={index} href={element.link} target="_blank" rel="noreferrer"
                           className={"w-inline-block " + (element.label === "ISO" ? 'iso' : '')}>
                            <div className="festa w-embed">
                                <img src={element.icon} alt={element.label} className={element.label === "ISO" ? 'iso' : ''}/>
                            </div>
                        </a>
                    ))}

                </div>
            </div>
        </footer>
    );
};

export default Footer;